import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaUpdateService } from 'app/core/pwa-update/pwa-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(private readonly pwaUpdateService: PwaUpdateService) {}
}
